import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import a from "../../../ellipsis/src/Ellipsis.js";
import { NPerformantEllipsis as f } from "../../../ellipsis/src/PerformantEllipsis.js";
import u from "../../../../../../../lodash-es@4.17.21/node_modules/lodash-es/get.js";
import { defineComponent as c, h as o } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const g = c({
  name: "DataTableCell",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    row: {
      type: Object,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    },
    column: {
      type: Object,
      required: !0
    },
    isSummary: Boolean,
    mergedTheme: {
      type: Object,
      required: !0
    },
    renderCell: Function
  },
  render() {
    var s;
    const {
      isSummary: p,
      column: l,
      row: r,
      renderCell: m
    } = this;
    let e;
    const {
      render: d,
      key: n,
      ellipsis: i
    } = l;
    if (d && !p ? e = d(r, this.index) : p ? e = (s = r[n]) === null || s === void 0 ? void 0 : s.value : e = m ? m(u(r, n), r, l) : u(r, n), i)
      if (typeof i == "object") {
        const {
          mergedTheme: t
        } = this;
        return l.ellipsisComponent === "performant-ellipsis" ? o(f, Object.assign({}, i, {
          theme: t.peers.Ellipsis,
          themeOverrides: t.peerOverrides.Ellipsis
        }), {
          default: () => e
        }) : o(a, Object.assign({}, i, {
          theme: t.peers.Ellipsis,
          themeOverrides: t.peerOverrides.Ellipsis
        }), {
          default: () => e
        });
      } else
        return o("span", {
          class: `${this.clsPrefix}-data-table-td__ellipsis`
        }, e);
    return e;
  }
});
export {
  g as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/TableParts/Cell.js
// module id = 1611
// module chunks = 41